import React, { useState } from "react";
import { useField, useFormikContext } from "formik";

// material
import {
  Container,
  FormControl,
  MenuItem,
  Typography,
  TextField,
  Stack
} from "@mui/material";

// components
import Page from "../../../components/Page";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";

// ----------------------------------------------------------------------

const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
};

export default function UploadFormPage2SecC(props) {
  const formikProps = useFormikContext();
  const [coAuthor, setCoAuthor] = useState(0);

  const {
    formField: {
      receivedDateSecC,
      submitDateSecC,
      acceptedDateSecC,
      revisedDateSecC,
      articleTitleSecC,
      manuscriptIDSecC,
      typeManuscriptSecC,
      journalSecC,
      subjectAreaCategorySecC,
      journalRankingSecC,
      authorsSecC,
      firstAuthorNameSecC,
      correspondingAuthorNameSecC,
      coauthorAbroadPublicationSecC,
      coauthorNameSecC,
      coResearcherUniversityInstituteNameSecC,
      coResearcherUniversityInstituteRankingSecC,
      supportedSecondCenturyFundSecC,
      uploadManuscriptSecC,
      documentsShowingsSubmissionSecC,
      publicationAcceptedEvidenceSecC,
      attachEvidenceTier1PaperSecC,
      attachEvidenceUniversityInstituteRankingSecC,
      additionalInformNoteSecC,
      additionalDocumentSecC
    }
  } = props;

  const [receivedDateSecCField, receivedDateSecCMeta] =
    useField(receivedDateSecC);
  const [submitDateSecCField, submitDateSecCMeta] = useField(submitDateSecC);
  const [acceptedDateSecCField, acceptedDateSecCMeta] =
    useField(acceptedDateSecC);
  const [revisedDateSecCField, revisedDateSecCMeta] = useField(revisedDateSecC);
  const [articleTitleSecCField, articleTitleSecCMeta] =
    useField(articleTitleSecC);
  const [manuscriptIDSecCField, manuscriptIDSecCMeta] =
    useField(manuscriptIDSecC);
  const [typeManuscriptSecCField, typeManuscriptSecCMeta] =
    useField(typeManuscriptSecC);
  const [journalSecCField, journalSecCMeta] = useField(journalSecC);
  const [subjectAreaCategorySecCField, subjectAreaCategorySecCMeta] = useField(
    subjectAreaCategorySecC
  );
  const [journalRankingSecCField, journalRankingSecCMeta] =
    useField(journalRankingSecC);
  const [authorsSecCField, authorsSecCMeta] = useField(authorsSecC);
  const [firstAuthorNameSecCField, firstAuthorNameSecCMeta] =
    useField(firstAuthorNameSecC);
  const [correspondingAuthorNameSecCField, correspondingAuthorNameSecCMeta] =
    useField(correspondingAuthorNameSecC);
  const [
    coauthorAbroadPublicationSecCField,
    coauthorAbroadPublicationSecCMeta
  ] = useField(coauthorAbroadPublicationSecC);
  const [coauthorNameSecCField, coauthorNameSecCMeta] =
    useField(coauthorNameSecC);
  const [
    coResearcherUniversityInstituteNameSecCField,
    coResearcherUniversityInstituteNameSecCMeta
  ] = useField(coResearcherUniversityInstituteNameSecC);
  const [
    coResearcherUniversityInstituteRankingSecCField,
    coResearcherUniversityInstituteRankingSecCMeta
  ] = useField(coResearcherUniversityInstituteRankingSecC);
  const [
    supportedSecondCenturyFundSecCField,
    supportedSecondCenturyFundSecCMeta
  ] = useField(supportedSecondCenturyFundSecC);
  const [uploadManuscriptSecCField, uploadManuscriptSecCMeta] =
    useField(uploadManuscriptSecC);
  const [
    documentsShowingsSubmissionSecCField,
    documentsShowingsSubmissionSecCMeta
  ] = useField(documentsShowingsSubmissionSecC);
  const [
    publicationAcceptedEvidenceSecCField,
    publicationAcceptedEvidenceSecCMeta
  ] = useField(publicationAcceptedEvidenceSecC);
  const [attachEvidenceTier1PaperSecCField, attachEvidenceTier1PaperSecCMeta] =
    useField(attachEvidenceTier1PaperSecC);
  const [
    attachEvidenceUniversityInstituteRankingSecCField,
    attachEvidenceUniversityInstituteRankingSecCMeta
  ] = useField(attachEvidenceUniversityInstituteRankingSecC);
  const [additionalInformNoteSecCField, additionalInformNoteSecCMeta] =
    useField(additionalInformNoteSecC);
  const [additionalDocumentSecCField, additionalDocumentSecCMeta] = useField(
    additionalDocumentSecC
  );

  return (
    <Page title="UploadFormPage2SecC">
      <Container maxWidth="xl">
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {receivedDateSecC.label}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={receivedDateSecCField.name}
                  value={receivedDateSecCField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        receivedDateSecCField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(
                        receivedDateSecCField.name,
                        date
                      );
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        receivedDateSecCMeta.touched &&
                          receivedDateSecCMeta.error
                      )}
                      helperText={
                        receivedDateSecCMeta.touched &&
                        receivedDateSecCMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {submitDateSecC.label}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={submitDateSecCField.name}
                  value={submitDateSecCField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        submitDateSecCField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(submitDateSecCField.name, date);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        submitDateSecCMeta.touched && submitDateSecCMeta.error
                      )}
                      helperText={
                        submitDateSecCMeta.touched && submitDateSecCMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </Stack>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {acceptedDateSecC.label}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={acceptedDateSecCField.name}
                  value={acceptedDateSecCField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        acceptedDateSecCField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(
                        acceptedDateSecCField.name,
                        date
                      );
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        acceptedDateSecCMeta.touched &&
                          acceptedDateSecCMeta.error
                      )}
                      helperText={
                        acceptedDateSecCMeta.touched &&
                        acceptedDateSecCMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {revisedDateSecC.label}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={revisedDateSecCField.name}
                  value={revisedDateSecCField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        revisedDateSecCField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(
                        revisedDateSecCField.name,
                        date
                      );
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        revisedDateSecCMeta.touched && revisedDateSecCMeta.error
                      )}
                      helperText={
                        revisedDateSecCMeta.touched && revisedDateSecCMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </Stack>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {articleTitleSecC.label}
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              name={articleTitleSecCField.name}
              value={articleTitleSecCField.value}
              onChange={(e) => articleTitleSecCField.onChange(e)}
              error={Boolean(
                articleTitleSecCMeta.touched && articleTitleSecCMeta.error
              )}
              helperText={
                articleTitleSecCMeta.touched && articleTitleSecCMeta.error
              }
            />
          </FormControl>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {manuscriptIDSecC.label}
              </Typography>
              <TextField
                name={manuscriptIDSecCField.name}
                value={manuscriptIDSecCField.value}
                onChange={(e) => manuscriptIDSecCField.onChange(e)}
                error={Boolean(
                  manuscriptIDSecCMeta.touched && manuscriptIDSecCMeta.error
                )}
                helperText={
                  manuscriptIDSecCMeta.touched && manuscriptIDSecCMeta.error
                }
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {typeManuscriptSecC.label}
              </Typography>
              <TextField
                name={typeManuscriptSecCField.name}
                value={typeManuscriptSecCField.value}
                onChange={(e) => typeManuscriptSecCField.onChange(e)}
                error={Boolean(
                  typeManuscriptSecCMeta.touched && typeManuscriptSecCMeta.error
                )}
                helperText={
                  typeManuscriptSecCMeta.touched && typeManuscriptSecCMeta.error
                }
              />
            </FormControl>
          </Stack>

          <FormControl fullWidth>
            <Typography variant="subtitle2">{journalSecC.label}</Typography>
            <TextField
              name={journalSecCField.name}
              value={journalSecCField.value}
              onChange={(e) => journalSecCField.onChange(e)}
              error={Boolean(journalSecCMeta.touched && journalSecCMeta.error)}
              helperText={journalSecCMeta.touched && journalSecCMeta.error}
            />
          </FormControl>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {subjectAreaCategorySecC.label}
              </Typography>
              <TextField
                name={subjectAreaCategorySecCField.name}
                value={subjectAreaCategorySecCField.value}
                onChange={(e) => subjectAreaCategorySecCField.onChange(e)}
                error={Boolean(
                  subjectAreaCategorySecCMeta.touched &&
                    subjectAreaCategorySecCMeta.error
                )}
                helperText={
                  subjectAreaCategorySecCMeta.touched &&
                  subjectAreaCategorySecCMeta.error
                }
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {journalRankingSecC.label}
              </Typography>
              <TextField
                select
                variant="outlined"
                name={journalRankingSecCField.name}
                value={journalRankingSecCField.value}
                onChange={(e) => journalRankingSecCField.onChange(e)}
                error={Boolean(
                  journalRankingSecCMeta.touched && journalRankingSecCMeta.error
                )}
                helperText={
                  journalRankingSecCMeta.touched && journalRankingSecCMeta.error
                }
              >
                <MenuItem value={"Tier 1"}>Tier 1</MenuItem>
                <MenuItem value={"Q1"}>Q1</MenuItem>
              </TextField>
            </FormControl>
          </Stack>

          <FormControl fullWidth>
            <Typography variant="subtitle2">{authorsSecC.label}</Typography>
            <TextField
              name={authorsSecCField.name}
              value={authorsSecCField.value}
              onChange={(e) => authorsSecCField.onChange(e)}
              error={Boolean(authorsSecCMeta.touched && authorsSecCMeta.error)}
              helperText={authorsSecCMeta.touched && authorsSecCMeta.error}
            />
          </FormControl>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {firstAuthorNameSecC.label}
              </Typography>
              <TextField
                name={firstAuthorNameSecCField.name}
                value={firstAuthorNameSecCField.value}
                onChange={(e) => firstAuthorNameSecCField.onChange(e)}
                error={Boolean(
                  firstAuthorNameSecCMeta.touched &&
                    firstAuthorNameSecCMeta.error
                )}
                helperText={
                  firstAuthorNameSecCMeta.touched &&
                  firstAuthorNameSecCMeta.error
                }
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {correspondingAuthorNameSecC.label}
              </Typography>
              <TextField
                name={correspondingAuthorNameSecCField.name}
                value={correspondingAuthorNameSecCField.value}
                onChange={(e) => correspondingAuthorNameSecCField.onChange(e)}
                error={Boolean(
                  correspondingAuthorNameSecCMeta.touched &&
                    correspondingAuthorNameSecCMeta.error
                )}
                helperText={
                  correspondingAuthorNameSecCMeta.touched &&
                  correspondingAuthorNameSecCMeta.error
                }
              />
            </FormControl>
          </Stack>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {coauthorAbroadPublicationSecC.label}
              </Typography>
              <TextField
                select
                variant="outlined"
                name={coauthorAbroadPublicationSecCField.name}
                value={coauthorAbroadPublicationSecCField.value}
                onChange={(e) => {
                  setCoAuthor(e.target.value);
                  coauthorAbroadPublicationSecCField.onChange(e);
                }}
                error={Boolean(
                  coauthorAbroadPublicationSecCMeta.touched &&
                    coauthorAbroadPublicationSecCMeta.error
                )}
                helperText={
                  coauthorAbroadPublicationSecCMeta.touched &&
                  coauthorAbroadPublicationSecCMeta.error
                }
              >
                <MenuItem value={1}>Yes, I have</MenuItem>
                <MenuItem value={0}>No, I have not</MenuItem>
              </TextField>
            </FormControl>

            {coAuthor === 1 && (
              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {coauthorNameSecC.label}
                </Typography>
                <TextField
                  required
                  placeholder="e.g. Professor Dr. Richard"
                  name={coauthorNameSecCField.name}
                  value={coauthorNameSecCField.value}
                  onChange={(e) => coauthorNameSecCField.onChange(e)}
                  error={Boolean(
                    coauthorNameSecCMeta.touched && coauthorNameSecCMeta.error
                  )}
                  helperText={
                    coauthorNameSecCMeta.touched && coauthorNameSecCMeta.error
                  }
                />
              </FormControl>
            )}
          </Stack>

          {coAuthor === 1 && (
            <Stack direction="row" spacing={6}>
              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {coResearcherUniversityInstituteNameSecC.label}
                </Typography>
                <TextField
                  name={coResearcherUniversityInstituteNameSecCField.name}
                  value={coResearcherUniversityInstituteNameSecCField.value}
                  onChange={(e) =>
                    coResearcherUniversityInstituteNameSecCField.onChange(e)
                  }
                  error={Boolean(
                    coResearcherUniversityInstituteNameSecCMeta.touched &&
                      coResearcherUniversityInstituteNameSecCMeta.error
                  )}
                  helperText={
                    coResearcherUniversityInstituteNameSecCMeta.touched &&
                    coResearcherUniversityInstituteNameSecCMeta.error
                  }
                  placeholder="e.g. Cambridge University"
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {coResearcherUniversityInstituteRankingSecC.label}
                </Typography>
                <TextField
                  select
                  variant="outlined"
                  name={coResearcherUniversityInstituteRankingSecCField.name}
                  value={coResearcherUniversityInstituteRankingSecCField.value}
                  onChange={(e) =>
                    coResearcherUniversityInstituteRankingSecCField.onChange(e)
                  }
                  error={Boolean(
                    coResearcherUniversityInstituteRankingSecCMeta.touched &&
                      coResearcherUniversityInstituteRankingSecCMeta.error
                  )}
                  helperText={
                    coResearcherUniversityInstituteRankingSecCMeta.touched &&
                    coResearcherUniversityInstituteRankingSecCMeta.error
                  }
                >
                  <MenuItem value={"Top 100 University_(QS or THE)"}>
                    Top 100 University_(QS or THE)
                  </MenuItem>
                  <MenuItem value={"Top 100 subject University_(QS or THE)"}>
                    Top 100 subject University_(QS or THE)
                  </MenuItem>
                  <MenuItem value={"Top institute"}>Top institute</MenuItem>
                  <MenuItem value={"Other"}>Other</MenuItem>
                </TextField>
              </FormControl>
            </Stack>
          )}

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {supportedSecondCenturyFundSecC.label}
            </Typography>
            <TextField
              select
              variant="outlined"
              name={supportedSecondCenturyFundSecCField.name}
              value={supportedSecondCenturyFundSecCField.value}
              onChange={(e) => supportedSecondCenturyFundSecCField.onChange(e)}
              error={Boolean(
                supportedSecondCenturyFundSecCMeta.touched &&
                  supportedSecondCenturyFundSecCMeta.error
              )}
              helperText={
                supportedSecondCenturyFundSecCMeta.touched &&
                supportedSecondCenturyFundSecCMeta.error
              }
            >
              <MenuItem value={"Yes, I do."}>Yes, I do.</MenuItem>
              <MenuItem value={"No, I do not."}>No, I do not.</MenuItem>
            </TextField>
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {uploadManuscriptSecC.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={uploadManuscriptSecCField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `uploadManuscriptSecC.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                uploadManuscriptSecCMeta.touched &&
                  uploadManuscriptSecCMeta.error
              )}
              helperText={
                uploadManuscriptSecCMeta.touched &&
                uploadManuscriptSecCMeta.error
              }
            />
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {documentsShowingsSubmissionSecC.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={documentsShowingsSubmissionSecCField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `documentsShowingsSubmissionSecC.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                documentsShowingsSubmissionSecCMeta.touched &&
                  documentsShowingsSubmissionSecCMeta.error
              )}
              helperText={
                documentsShowingsSubmissionSecCMeta.touched &&
                documentsShowingsSubmissionSecCMeta.error
              }
            />
            <Typography>
              For those who have already submitted a research paper, but have
              not accepted yet.
            </Typography>
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {publicationAcceptedEvidenceSecC.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={publicationAcceptedEvidenceSecCField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `publicationAcceptedEvidenceSecC.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                publicationAcceptedEvidenceSecCMeta.touched &&
                  publicationAcceptedEvidenceSecCMeta.error
              )}
              helperText={
                publicationAcceptedEvidenceSecCMeta.touched &&
                publicationAcceptedEvidenceSecCMeta.error
              }
            />
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {attachEvidenceTier1PaperSecC.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={attachEvidenceTier1PaperSecCField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `attachEvidenceTier1PaperSecC.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                attachEvidenceTier1PaperSecCMeta.touched &&
                  attachEvidenceTier1PaperSecCMeta.error
              )}
              helperText={
                attachEvidenceTier1PaperSecCMeta.touched &&
                attachEvidenceTier1PaperSecCMeta.error
              }
            />
          </FormControl>

          {coAuthor === 1 && (
            <FormControl>
              <Typography variant="subtitle2">
                {attachEvidenceUniversityInstituteRankingSecC.label}
              </Typography>
              <TextField
                inputProps={{
                  accept:
                    "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
                }}
                type="file"
                name={attachEvidenceUniversityInstituteRankingSecCField.name}
                onChange={(event) => {
                  formikProps.setFieldValue(
                    `attachEvidenceUniversityInstituteRankingSecC.file`,
                    event.currentTarget.files[0]
                  );
                }}
                error={Boolean(
                  attachEvidenceUniversityInstituteRankingSecCMeta.touched &&
                    attachEvidenceUniversityInstituteRankingSecCMeta.error
                )}
                helperText={
                  attachEvidenceUniversityInstituteRankingSecCMeta.touched &&
                  attachEvidenceUniversityInstituteRankingSecCMeta.error
                }
              />
            </FormControl>
          )}

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {additionalInformNoteSecC.label}
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              name={additionalInformNoteSecCField.name}
              value={additionalInformNoteSecCField.value}
              onChange={(e) => additionalInformNoteSecCField.onChange(e)}
              error={Boolean(
                additionalInformNoteSecCMeta.touched &&
                  additionalInformNoteSecCMeta.error
              )}
              helperText={
                additionalInformNoteSecCMeta.touched &&
                additionalInformNoteSecCMeta.error
              }
            />
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {additionalDocumentSecC.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={additionalDocumentSecCField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `additionalDocumentSecC.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                additionalDocumentSecCMeta.touched &&
                  additionalDocumentSecCMeta.error
              )}
              helperText={
                attachEvidenceUniversityInstituteRankingSecCMeta.touched &&
                attachEvidenceUniversityInstituteRankingSecCMeta.error
              }
            />
          </FormControl>
        </Stack>
      </Container>
    </Page>
  );
}
